import { render } from "./component-mail-index.vue?vue&type=template&id=5377ca10"
import script from "./component-mail-index.vue?vue&type=script&setup=true&lang=js"
export * from "./component-mail-index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-mail-index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5377ca10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5377ca10', __exports__)) {
    api.reload('5377ca10', __exports__)
  }
  
  module.hot.accept("./component-mail-index.vue?vue&type=template&id=5377ca10", () => {
    api.rerender('5377ca10', render)
  })

}


export default __exports__